module.exports = __webpack_public_path__ + "media/nicole6.058c4dac.mp3";